import { API } from '../api'
import { Contracts, ContractsResponse } from './interface'

export const fetchAll = async (
  filtros: Record<string, any>
): Promise<{
  items: Contracts[]
  numbers: {
    total: number
    integrados: number
    erro: number
  }
  total: number
}> => {
  try {
    const response = await API.get<ContractsResponse>('contratos', filtros)

    const results = response.resultado
    const contracts = results.contratos
    const numbers = {
      total: results.qtdTotal ?? 0,
      integrados: results.qtdIntegrados ?? 0,
      erro: results.qtdComErro ?? 0
    }
    const total = results.qtdTotal ?? 0

    return { items: contracts, numbers, total }
  } catch (error) {
    console.error('Erro ao buscar operadoras:', error)
    return {
      items: [],
      numbers: {
        total: 0,
        integrados: 0,
        erro: 0
      },
      total: 0
    }
  }
}
